<template>
  <q-dialog
    no-route-dismiss
    :value="selectedProductOpen"
    @show="show()"
    @hide="close()">
    <q-layout view="Lhh lpR fff" container class="bg-white" style="height:800px;">
      <q-header class="transparent">
        <q-btn  color="primary" v-close-popup  dense icon="close" style="float:right" />
      </q-header>
      <q-footer class="bg-white">
        <q-btn style="float:right; margin:5px 20px 10px 0px;" dense flat color="primary" label="Save" v-close-popup />
      </q-footer>
        <q-page-container style="margin-top: -40px">
          <q-page padding v-if="!$apollo.loading && product">
            <div class="productcard-tag-new">
              <q-badge class="customBadge" color="blood" label="5% OFF" v-if="storeType == 'container' && ['360','Simpl','Anti Gravity','Arctic Grip','Grizzly','Next', 'Trickit' ].includes(productAttribute('brand')) " ></q-badge>
            </div>
            <q-carousel
              swipeable
              animated
              arrows
              transition-prev="jump-right"
              transition-next="jump-left"
              v-model="slide"
              navigation
              control-color="primary"
              infinite >
              <q-carousel-slide v-bind:key="i" v-for="(img, i) in product.images" :name="i">
                <q-img :src="img.url"
                contain
                style="width: 100%; height: 100%"
                native-context-menu
                class="full-width" />
              </q-carousel-slide>
            </q-carousel>
            <div class="row no-wrap items-center">
              <div class="col text-h5" style="padding-bottom: 0;">{{product.name}}</div>
            </div>
            <div class="text-subtitle1">
              {{productAttribute('brand')}}・{{productAttribute('range')}}
            </div>
            <div class="text-subtitle2 text-grey">
              {{productAttribute('grip') ? productAttribute('grip') + '・' : ''}}{{productSize ? productSize + '・' : ''}}{{productAttribute('material')}}
            </div>
            <div class="text-subtitle2 text-grey" v-if="productAttribute('holds') && productAttribute('holds') > 0">
              Holds: <span>{{productAttribute('holds')}}</span>
            </div>
            <div class="text-subtitle2 text-grey" v-if="(productAttribute('screws')||[]).length">
              Screws:
              <span v-bind:key="screw.name" v-for="(screw, i) in (productAttribute('screws')||[])">{{screw.qty}} x {{screw.type}}{{i === (productAttribute('screws')||[]).length-1?'':', '}}</span>
            </div>
            <div class="text-subtitle2 text-grey" v-if="(productAttribute('bolts')||[]).length">
              Bolts: <span v-bind:key="bolt.name" v-for="(bolt, i) in (productAttribute('bolts')||[])">{{bolt.qty}} x {{bolt.type}}{{i === (productAttribute('bolts')||[]).length-1?'':', '}}</span>
            </div>
            <div class="text-subtitle2 text-grey" v-html="product.description"></div>
            <div style="text-align: right; margin-right: 20px" v-if="storeType == 'container'">
              <!-- <s style="color:black; font-size:14px">{{ formattedPrice }}</s>&nbsp<b style="color:red; font-size:16px">{{ Number(rawPrice)*1.25}} </b> -->
               <div v-if="['360','Simpl','Anti Gravity','Arctic Grip','Grizzly','Next', 'Trickit' ].includes(productAttribute('brand'))">
                <s style="color:black; font-size:24px">${{  Number(Number(formattedProductPrice.substring(1))/1.045).toFixed(2) }}</s>&nbsp<b style="color:red; font-size:28px">{{ Number(Number(formattedProductPrice.substring(1))/1.10).toFixed(2)}}</b>
               </div>
               <div v-else>
                <p style="color:black; font-size:24px">${{  Number(Number(formattedProductPrice.substring(1))/1.1).toFixed(2) }}</p>
               </div>
              <p style="color:silver; font-size:9px; width: 100%;text-align: right;" v-if="storeType == 'container'">gst not included</p>
            </div>
            <div style="font-size:28px;" v-else>{{formattedProductPrice}}</div>
            <humm-info :price="Number(product.skus[0].retailPrice).toFixed(2)"v-if="storeType == 'retail'"></humm-info>
            <q-table
              :data="skuData"
              :columns="skuColumns"
              row-key="name"
              flat
              hide-bottom
              :pagination="{rowsPerPage: 0}"
              class="my-sticky-header-table">
              <template v-slot:header-cell-stock="props">
                <q-th :props="props" style="padding: 0px; max-width:80px">
                  {{ props.col.label }}
                </q-th>
              </template>
              <template v-slot:body-cell-colour="props">
                <td props="props" style="max-width: 120px; text-overflow: ellipsis; overflow:hidden">
                  <div style="" :style="{border: '1px silver solid', backgroundColor: props.row.options.colour.hex, width: '10px',height: '10px',marginRight:'5px'}" class="inline-block"></div>
                  <span>{{props.row.options.colour.group}}</span><br><span>{{' (' + props.row.options.colour.name + ')'}}</span><br>
                </td>
              </template>
              <template v-slot:body-cell-stock="props">
                <td class="text-center" props="props" style="width: 10px;">
                  <span>{{props.row.stock}}</span>
                </td>
              </template>
              <template v-slot:body-cell-inBasket="props">
                <td props="props">
                  <div style="width:100px; margin:auto">
                    <q-input @input="v => updateBasketWithLimit(props.row, v)" :min="0" :max="maxStockForItem(props)" :value="props.value" debounce="1000" id="cu" class="cui" maxlength="5" dense outlined input-style="font-weight:bold; text-align:center; width:40px; margin-left: -5px; margin-right:-50px; padding: 0" >
                      <template v-slot:prepend>
                        <q-btn @click="removeOne(props.row)" class="minusButton" size="10px" color="black" stretch  flat icon="remove" style="width: 25px; height: 30px; margin-left: -12px" />
                      </template>
                      <template v-slot:append>
                        <q-btn @click="addOne(props.row)" class="plusButton" size="10px" color="black" stretch  flat icon="add" style="width: 25px; height: 30px; margin-right: -12px" />
                      </template>
                    </q-input>
                  </div>
                </td>
              </template>
            </q-table>
          </q-page>
        </q-page-container>
      </q-layout>
    </q-dialog>
</template>

<script>
import gql from 'graphql-tag'
import { format } from 'quasar'
import StoreTypes from './StoreTypes'
import { properCase } from '../util/string'
import moment from 'moment'
const { capitalize } = format

export default {
  name: 'ProductDialog',
  components: {
    HummInfo: () => import('../components/HummInfo.vue')
  },
  props: ['storeType'],
  apollo: {
    cart () {
      return {
        query: gql`
        query cart ($id: ID!) {
          cart(id: $id) {
            id
            items {
              id,
              skuId
              qty
              stockType
              ETA
              sku {
                id
              }
            }
          }
        }
      `,
        variables () {
          return {
            id: this.cartId
          }
        },
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        // skip () {
        //   return !this.$store.state.auth.currentAccount
        // },
        fetchPolicy: 'network-only'
      }
    },
    product () {
      return {
        query: gql`
            query ($id: ID!) {
              product(id: $id) {
                id
                name
                attributes
                images {
                  url
                  name
                }
                urlSlug
                description
                skus {
                  id
                  price
                  containerPrice
                  showInContainer
                  showInRetail
                  hideInStock
                  retailPrice
                  options
                  stock
                  showPreStock
                  preStock
                  availableOn
                }
              }
            }
        `,
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        fetchPolicy: 'network-only',
        update (response) {
          this.slide = 0 // ((response.product.images || [])[0] || {}).name
          return response.product
        },
        variables () {
          return {
            id: this.productId
          }
        },
        skip () {
          return !this.productId
        }
      }
    }
  },
  data () {
    return {
      priceToShow: '',
      arrivalDate: 'Soon',
      preStockItem: false,
      slide: 0,
      rawSkuColumns: [
        {
          name: 'colour',
          required: true,
          label: 'Colour',
          field: row => row.options.colour.group + ' ' + row.options.colour.name,
          align: 'left'
        },
        {
          name: 'price',
          required: true,
          label: 'Price',
          field: row => {
            if (this.storeType === 'container') {
              return Number(row[this.priceFieldName]) / 1.10
            }
            if (this.priceFieldName == 'price') {
              return row[this.priceFieldName] * this.storeDiscount
            } else {
              return row[this.priceFieldName]
            }
          },
          format: (val, row) => `$${Number(val).toFixed(2)}`,
          align: 'center'
        },
        {
          name: 'stock',
          required: false,
          label: 'Stock',
          field: row => row.stock,
          align: 'center'
        },
        {
          name: 'inBasket',
          required: false,
          label: 'On Cart',
          field: row => row.inBasket,
          align: 'center'
        }
      ]
    }
  },
  computed: {
    isPreStock () {
      return this.getIsPreStock()
    },
    storeDiscount () {
      if (this.storeType === 'stock') {
        return (100 - this.$store.state.auth.storeSettings.stockStoreDiscount) / 100
      } else {
        return 1
      }
    },
    currentUUID () {
      return this.$store.state.auth.currentUUID
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    cartId () {
      if (this.storeType === StoreTypes.STOCK) {
        return this.$store.state.auth.currentAccount?.activeCartId
      } else if (this.storeType === StoreTypes.CONTAINER) {
        return this.$store.state.auth.currentAccount?.activeContainerCartId
      } else if (this.storeType === StoreTypes.RETAIL) {
        if (this.currentAccount) {
          return this.$store.state.auth.currentAccount?.activeRetailCartId
        } else {
          return this.$store.state.auth.currentGuest.activeRetailCartId
        }
      }
      console.error(`Unknown storeType for ProductDialog: ${this.storeType}`)
      return ''
    },
    productSize () {
      return {
        'xxs': 'XXSmall',
        'xs': 'XSmall',
        's': 'Small',
        'm': 'Medium',
        'l': 'Large',
        'xl': 'XLarge',
        'xxl': 'XXLarge'
      }[this.productAttribute('size').toLowerCase()]
    },
    priceFieldName () {
      return {
        [StoreTypes.CONTAINER]: 'containerPrice',
        [StoreTypes.RETAIL]: 'retailPrice',
        [StoreTypes.STOCK]: 'price'
      }[this.storeType]
    },
    formattedProductPrice () {
      if (!this.product.skus.length) return 'Out of stock'
      const prices = this.product.skus.map(p => Number(p[this.priceFieldName]))

      const pMin = Math.min(...prices).toFixed(2)
      const pMax = Math.max(...prices).toFixed(2)
      // this.priceToShow = pMin;
      this.priceToShow = pMax
      // if (pMin === pMax) return `$${pMin}`
      // else return `$${pMin} - $${pMax}`
      return `$${pMax}`
    },
    selectedProductOpen () {
      return this.$store.state.products.selectedProductOpen
    },
    filters () {
      return this.$store.state.filters.filters
    },
    colourFilter () {
      return this.filters?.find?.(filter => filter.type === 'colour')
    },
    productId () {
      return this.$store.state.products.selectedProductId
    },
    attributeData () {
      let data = []
      Object.keys(this.product.attributes).forEach(k => {
        data.push({
          name: capitalize(k),
          value: this.product.attributes[k]
        })
      })
      return data
    },
    skuData () {
      let data = []
      this.product.skus.forEach(sku => {
        let o = {}
        Object.keys(sku).forEach(k => {
          o[k] = sku[k]
        })
        const cartItem = this.cart.items.find(item => item.skuId === sku?.id)
        o.inBasket = cartItem?.qty || 0
        data.push(o)
      })
      if (this.colourFilter) {
        data = data.filter(sku => sku.options?.colour && this.colourSelectedInColourFilter(sku.options?.colour)
        )
      }
      // TODO: Should be able to remove some of these in the future once we filter them in the backend.
      if (this.storeType === StoreTypes.CONTAINER) {
        data = data.filter(v => v.showInContainer)
      }
      if (this.storeType === StoreTypes.RETAIL) {
        data = data.filter(v => v.showInRetail)
      }
      if (this.storeType === StoreTypes.STOCK) {
        data = data.filter(v => !v.hideInStock || v.showPreStock)
      }
      return [StoreTypes.STOCK, StoreTypes.RETAIL].includes(this.storeType.toLowerCase()) ? data.filter(v => v.stock > 0) : data
    },
    skuColumns () {
      return this.rawSkuColumns.filter(col => (col.name !== StoreTypes.STOCK) || [StoreTypes.STOCK, StoreTypes.RETAIL].includes(this.storeType.toLowerCase()))
    }
  },
  methods: {
    getIsPreStock () {
      if (this.storeType === 'stock') {
        for (let sku of this.product.skus) {
          if (sku.showPreStock && sku.preStock > 0) {
            this.arrivalDate = moment(sku.availableOn).format('MMM')
            this.preStockItem = true
            return true
          }
        }
      }
    },
    addOne (item) {
      let inBasket = Number(item.inBasket)
      if (this.storeType == StoreTypes.CONTAINER) {
        item.inBasket++
        this.updateBasket(item, item.inBasket)
        return
      }

      if (inBasket + 1 <= item.stock) {
        item.inBasket++
        this.updateBasket(item, item.inBasket)
      } else {
      }
    },
    removeOne (item) {
      let qty = Number(item.inBasket)

      if (qty - 1 >= 0) {
        this.updateBasket(item, item.inBasket - 1)
      } else {
      }
    },
    updateBasketWithLimit (item, value) {
      if (this.storeType == StoreTypes.CONTAINER) {
        this.updateBasket(item, value)
      } else {
        if (value <= item.stock) {
          this.updateBasket(item, value)
        } else {
          this.updateBasket(item, item.stock)
        }
      }
    },
    /**
     * Checks if a colour is selected in the colour filter (if the filter exists)
     */
    colourSelectedInColourFilter (colourObj) {
      // let colourFilter = this.colourFilter.values;
      // let match = false;

      // if(colourFilter.superGroups.length){
      //   if(colourFilter.superGroups.includes(colourObj?.superGroup)){
      //     match = true
      //   }
      // }else if(!match && colourFilter.groups.length){
      //   colourFilter.groups.forEach(element => {
      //     if(element.superGroup == colourObj?.superGroup && element.group == colourObj?.group){
      //       match = true
      //     }
      //   })
      // }else if(!match && colourFilter.colours.length){
      //   colourFilter.colours.forEach(element => {
      //     if(element.superGroup == colourObj?.superGroup && element.group == colourObj?.group && element.colour == colourObj?.name){
      //       match = true
      //     }
      //   })
      // }
      return true
    },
    productAttribute (key) {
      return this.product?.attributes?.[key]
    },
    show () {
      // history.replaceState('', `${this.product?.attributes?.brand} ${this.product?.attributes?.range}`, `/#${this.$router.currentRoute.path}`)
    },
    close () {
      this.$store.commit('setSelectedProductId', null)
    },
    async updateBasket (sku, value) {
      // if (this.inputType === 'number') updatedValue = Number(updatedValue)
      // const input = { [this.field]: updatedValue }
      value = Number(value)
      try {
        if (value > 0 && !this.cart.items.find(item => item.skuId === sku?.id)) {
          await this.$apollo.mutate({
            mutation: gql`mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
                addItemToCart (id: $cartId, input: $input) {
                    id
                    items {
                        id,
                        skuId,
                        stockType
                        ETA
                        sku {
                            id
                            price
                            containerPrice
                            retailPrice
                            options
                            stock
                            product {
                                id
                            }
                        }
                        qty
                    }
                }
            }
            `,
            variables: {
              cartId: this.cart.id,
              input: {
                skuId: sku?.id,
                qty: value,
                stockType: this.preStockItem ? 'pre-stock' : 'in-stock',
                ETA: sku?.availableOn || ''
              }
            },
            context: {
              headers: {
                uuid: this.currentUUID
              }
            },
            skip () {
              return !value
            }
          })
          // should search for sku in product!? - then add product under sku? - or add more depth to cart query...
          const skuToSendToAnalytics = this.cart.items.find(item => item.skuId === sku?.id).sku
          // eslint-disable-next-line no-undef
          analytics.track('Add Item To Cart', {
            storeType: this.$store.state.cart.currentStoreType,
            cartId: this.cartId,
            skuId: sku?.id,
            sku: skuToSendToAnalytics,
            qty: value,
            where: 'product dialog'
          })
        } else if (value === 0 && this.cart.items.find(item => item.skuId === sku?.id)) {
          await this.$apollo.mutate({
            mutation: gql`mutation deleteItemFromCart($cartId: ID!, $skuId: ID!) {
              deleteItemFromCart (id: $cartId, skuId: $skuId) {
                  id
                  items {
                      id
                      skuId
                      qty
                      stockType
                      ETA
                  }
              }
          }
          `,
            variables: {
              cartId: this.cart.id,
              skuId: sku?.id
            },
            context: {
              headers: {
                uuid: this.currentUUID
              }
            }
          })
          // eslint-disable-next-line no-undef
          analytics.track('Delete Item From Cart', {
            storeType: this.$store.state.cart.currentStoreType,
            cartId: this.cartId,
            where: 'product dialog',
            skuId: sku?.id
          })
        } else if (this.cart.items.find(item => item.skuId === sku?.id)) {
          await this.$apollo.mutate({
            mutation: gql`mutation editItemInCart($cartId: ID!, $skuId: ID!, $input: CartItemInput!) {
                editItemInCart (id: $cartId, skuId: $skuId, input: $input) {
                    id
                    items {
                        id
                        skuId
                        qty
                        stockType
                        ETA
                    }
                }
            }
            `,
            variables: {
              cartId: this.cart.id,
              skuId: sku?.id,
              input: {
                qty: value,
                stockType: this.preStockItem ? 'pre-stock' : 'in-stock',
                ETA: sku?.availableOn || ''
              }
            },
            context: {
              headers: {
                uuid: this.currentUUID
              }
            }
          })
          // eslint-disable-next-line no-undef
          analytics.track('Edit Item In Cart', {
            storeType: this.$store.state.cart.currentStoreType,
            cartId: this.cart.id,
            skuId: sku?.id,
            updates: {
              qty: value
            },
            where: 'product dialog'
          })
        }
      } catch (err) {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`, this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0))
    },
    maxStockForItem (props) {
      return (this.storeType || '').toLowerCase() === StoreTypes.CONTAINER ? 99999 : props.row.stock
    }

  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';

>>> .q-table{
  overflow: hidden;
}

>>> td {
    padding: 0px;

}

>>> .q-field{
  width: 92px
}

>>> .q-field__control {
  max-height: 30px;
}

>>> .q-field__native {
  max-height: 30px;
}

>>> .q-field__control:after {
  max-height: 30px;
}

>>> .minusButton .q-icon {
  margin-left:-6px
  margin-top:2px
}

>>> .plusButton .q-icon {
  margin-left:-6px
  margin-top:2px
}
   .customBadgePreStock {
    padding: 3px 6px;
    font-size: 14px;
    border: 2px solid #C5171C;
    color: #C5171C;
    background-color: white;
  }

  .productcard-tag-new {
    font-weight: bold;
    top: 10px;
    right: 10px;
    z-index: 99;
    text-align: right;
  }

</style>
